<template>
    <div v-if="showRestartPopup" class="popup" @click.self="continueBooking">
        <div class="popup-content p-8 flex flex-col gap-4">
            <div class="flex flex-row justify-end">
                <div class="popup-close" @click="continueBooking">
                    {{ i18n.t('popupResetWizard.close') }}
                    <span class="popup-close-icon"></span>
                </div>
            </div>
            <h2>{{ i18n.t('popupResetWizard.title') }}</h2>
            <p>{{ i18n.t('popupResetWizard.description') }}</p>
            <div class="flex flex-row flex-wrap gap-4">
                <button class="button button-alt" @click="continueBooking">{{ i18n.t('popupResetWizard.continue') }}</button>
                <button class="button button-alt" @click="stepsStore.reset()">{{ i18n.t('popupResetWizard.restart') }}</button>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import { storeToRefs } from 'pinia';
import { useI18n } from 'vue-i18n';
import { useRestartWizardStore } from '@/widgets/Wizard/stores/restart-wizard';
import { useStepsStore } from '@/widgets/Wizard/stores/steps';

const i18n = useI18n();

const restartWizardStore = useRestartWizardStore();
const { startRestartTimer, stopRestartTimer } = restartWizardStore;
const { showRestartPopup } = storeToRefs(restartWizardStore);

const stepsStore = useStepsStore();

function continueBooking() {
    showRestartPopup.value = false;

    stopRestartTimer();
    startRestartTimer();
}
</script>
